import { Link } from 'react-router-dom';
import BackButton from '../../components/ui/atoms/BackButton';

const TermsOfService = () => (
  <div className="px-4 pb-28 pt-14 max-w-3xl mx-auto mt-10">
    <BackButton />
    <h1 className="text-2xl font-semibold mb-4">Terms of Service</h1>
    <p className="mb-2">
      <strong>Effective date:</strong> June 11, 2025
    </p>

    <h2 className="text-xl font-semibold mt-6 mb-2">1. Acceptance</h2>
    <p>
      By using PanPals ("App"), you agree to these Terms of Service. If you do not agree to these terms, do not use the App.
      PanPals is operated by Mohsen Nasiri, based in Germany.
    </p>

    <h2 className="text-xl font-semibold mt-6 mb-2">2. Eligibility</h2>
    <p>
      You must be at least 16 years old to use this App.
    </p>
    <p>
      Our App is not directed to children under 13. If you’re under 13, you must have parental consent. We comply with COPPA (Children’s Online Privacy Protection Act).
    </p>

    <h2 className="text-xl font-semibold mt-6 mb-2">3. Account and Content</h2>
    <ul className="list-disc list-inside space-y-1">
      <li>You are solely responsible for all activity on your account.</li>
      <li>You retain rights to your uploaded content (e.g. recipes, images), but grant us a worldwide, non-exclusive, royalty-free license to use, display, and share your content within the App.</li>
      <li>Content must not infringe any intellectual property rights, violate laws, or include harmful or misleading information.</li>
    </ul>

    <h2 className="text-xl font-semibold mt-6 mb-2">4. License to Use the App</h2>
    <p>
      We grant you a limited, non-exclusive, non-transferable, and revocable license to use the App for personal, non-commercial purposes in accordance with these Terms.
    </p>

    <h2 className="text-xl font-semibold mt-6 mb-2">5. Public Profiles</h2>
    <p>
      Your profile may be visible to other users, including your display name, avatar, and shared recipes. Your email and sensitive data are never shared publicly.
    </p>

    <h2 className="text-xl font-semibold mt-6 mb-2">6. User Conduct</h2>
    <ul className="list-disc list-inside space-y-1">
      <li>No harassment, hate speech, or illegal behavior are permitted.</li>
      <li>No spamming, solicitation, or advertising without consent are permitted.</li>
      <li>Do not reverse-engineer, tamper with, or interfere with the App's operation or security.</li>
    </ul>

    <h2 className="text-xl font-semibold mt-6 mb-2">7. Moderation and Reporting</h2>
    <p>
      We reserve the right to remove content or suspend accounts that violate these terms. Users may report inappropriate content using the in-app reporting tools.
    </p>

        <h2 className="text-xl font-semibold mt-6 mb-2">8. Subscription & Payments</h2>
    <p>
      PanPals is free to use. An optional subscription (€1.99/month) unlocks advanced dietary filters (e.g. allergens, cuisines, budgets).
    </p>
    <ul className="list-disc list-inside space-y-1">
      <li>
        <strong>iOS:</strong> Subscriptions are purchased via Apple&nbsp;In-App Purchase.  
        Manage or cancel anytime in your Apple ID → Subscriptions settings.
      </li>
      <li>
        <strong>Android:</strong> Subscriptions are purchased via Google Play Billing.  
        Manage or cancel anytime in your Google Play → Subscriptions section.
      </li>
      <li>
        <strong>Web:</strong> Subscriptions can be purchased at panpals.de via Stripe.  
        You may manage, cancel, or obtain refunds in the Stripe Customer Portal.
      </li>
    </ul>
    <p>
      All subscriptions auto-renew monthly unless canceled at least 24 hours before the end of the current period.  
      EU residents have a 14-day right of withdrawal under consumer law; cancelling within this window voids the first charge.
    </p>
    <p>
      No long-term commitment—cancel anytime through the above methods to avoid further billing.
    </p>

    <h2 className="text-xl font-semibold mt-6 mb-2">9. Limitation of Liability</h2>
    <p>
      To the extent permitted under applicable law, PanPals is not liable for indirect, incidental, or consequential damages. This includes any harm from incorrect nutritional data or allergic reactions. This App does not provide medical advice.
      The App is provided "as is" and "as available" without warranties of any kind, either express or implied. We do not guarantee uninterrupted or error-free operation.
    </p>

    <h2 className="text-xl font-semibold mt-6 mb-2">10. Termination</h2>
    <p>
      We may suspend or terminate your access to the App at any time if you breach these terms. You may delete your account at any time via the settings menu.
    </p>

    <h2 className="text-xl font-semibold mt-6 mb-2">11. Governing Law</h2>
    <p>
      These Terms are governed by the laws of Germany. Any legal disputes shall be resolved in the courts of Berlin.
      The application of the United Nations Convention on Contracts for the International Sale of Goods (CISG) is excluded.
    </p>

    <h2 className="text-xl font-semibold mt-6 mb-2">12. Privacy Policy and Imprint</h2>
    <p>
      For information about how we handle personal data, please see our{' '}
      <Link 
        to="../privacy"
        className="text-blue-600 underline hover:text-blue-800"
      >
        Privacy Policy
      </Link>.
    </p>
    <p>
      For legal contact and provider information, see our{' '}
      <Link 
        to="../imprint"
        className="text-blue-600 underline hover:text-blue-800"
      >
        Imprint
      </Link>.
    </p>

    <h2 className="text-xl font-semibold mt-6 mb-2">13. Language</h2>
    <p>
      These Terms are provided in English, which is the binding language of this agreement.
    </p>

    <h2 className="text-xl font-semibold mt-6 mb-2">14. Contact</h2>
    <p>
      If you have any questions about these Terms, please contact us at{' '}
      <Link 
        to="mailto:support@panpals.de"
        className="text-blue-600 underline hover:text-blue-800"
      >
        support@panpals.de
      </Link>.
    </p>

    <h2 className="text-xl font-semibold mt-6 mb-2">15. Changes to These Terms</h2>
    <p>
      We may update these Terms from time to time. When we do, the effective date will be revised, and continuing to use the App after changes means you accept the updated terms.
    </p>
  </div>
);

export default TermsOfService;
